import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
//import SchoolIcon from '@material-ui/icons/School';
import Paper from '@material-ui/core/Paper';
//------Material UI-----/
import { makeStyles, useTheme } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import AccessTimeIcon from '@material-ui/icons/AccessTime';
import queryString from 'querystring';
import React, { useEffect, useRef, useState } from 'react';
import ReactPlayer from 'react-player';
import usePortalAuth from '../../../auth/usePortalAuth';
import basePCUrl from '../../../Globals';

import useChangePageTitle from '../CustomHooks/useChangePageTitle';
import LinearProgress from '@material-ui/core/LinearProgress';

import TrainingCompleteModal from './TrainingCompleteModal';

//----CSS/Styling Sheet----//
import './TrainingSuite.css';
import useGetTrainingByID from './useGetTrainingByID';
import { LoadingSpinner } from '../LoadingSpinner/LoadingSpinner';
import { Train } from '@material-ui/icons';



const TrainingSuite = (props) => {
  const reactPlayerRef = useRef();

  const [trainingId, setTrainingId] = useState('');
  const [infographicOpen, setInfographicOpen] = useState(false);
  const [isOpen, setIsOpen] = useState(false);

  //console.log(props.trainingData)

  const preferredLanguage = props.preferredLanguage;
  const getTranslation = props.getTranslation;

  const [trainingState, setTrainingState] = useState({
    trainingFlag: false,
    videoType: null,
    frequency: null,
    completionIndicator: null,
    video: false,
    pdf: false,
    quiz: false,
    yellowClick: false,
    redClick: false,
  });

  const { trainingFlag, videoType, frequency, completionIndicator, video, pdf, quiz, yellowClick, redClick } =
    trainingState;

  const {
    data,
    trainingVideo,
    trainingGraphic,
    trainingTitle,
    trainingTimeEstimate,
    trainingStatus,
    trainingQuiz,
    isLoading,
  } = useGetTrainingByID(trainingId, videoType);

  const [isLoadingTraining, setIsLoadingTraining] = useState(true);
  const { getAccessTokenSilently } = usePortalAuth();

  if (trainingTitle) {
    document.title = 'Training Module ' + trainingTitle;
  }

  const analyzeLink = () => {
    let parsedQuery = queryString.parse(props.location.search);
    let parsedId = parsedQuery.id;

    if (parsedId !== undefined) {
      let parsedId = parsedQuery.id;
      //var decodedLink = decodeURIComponent(parsedId);
      setTrainingId(parsedId);
    }
  };

  useEffect(() => {
    analyzeLink();
    listeningVideo();
  }, [trainingId, videoType]);

  useEffect(() => {
    const handleVisibilityChange = () => {
      if (!document.hidden || !reactPlayerRef.current) {
        return;
      }

      const internalPlayer = reactPlayerRef.current.getInternalPlayer?.();
      if (!internalPlayer) {
        return;
      }

      if (typeof internalPlayer.pauseVideo === 'function') {
        internalPlayer.pauseVideo();
        return;
      }

      if (typeof internalPlayer.pause === 'function') {
        internalPlayer.pause();
      }
    };

    document.addEventListener('visibilitychange', handleVisibilityChange);
    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  }, []);

  const listeningVideo = () => {
    if (video) {
      var trainingVideoPlayer = document.getElementById('trainingVideo');

      trainingVideoPlayer.addEventListener('ended', function (e) {
        saveTrainingProgress();
        console.log('video finished');
      });
    }
  };

  const getAdminConfigSettings = async () => {
    const token = await getAccessTokenSilently();

    return new Promise(async (resolve, reject) => {
      setIsLoadingTraining(true);

      fetch(basePCUrl, {
        method: 'get',
        headers: {
          Action: 'adminConfigs',
          //testacct: uid,
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      })
        .then((response) => {
          if (response.status !== 200) {
            console.log('Looks like there was a problem. Status Code: ' + response.status);
            return;
          }

          response.json().then((data) => {
            if (data !== 'access token check failed') {
              setTrainingState({
                trainingFlag: data.settings.trainingSettings.trainingFlag,
                videoType: data.settings.trainingSettings.videoType,
                frequency: data.settings.trainingSettings.trainingFrequency,
                completionIndicator: data.settings.trainingSettings.completionIndicator,
                yellowClick: data.settings.trainingSettings.ongoingTraining.yellowClick,
                redClick: data.settings.trainingSettings.ongoingTraining.redClick,
              });
              setIsLoadingTraining(false);
              resolve(data);
            } else {
              resolve(data);
              return;
            }
          });
        })
        .catch(function (err) {
          console.log('Fetch Error :-S', err);
        });
    });
  };

  const saveTrainingProgress = async (event) => {
    //event.preventDefault();
    const token = await getAccessTokenSilently();
    var api = 'https://zsvz1vz9rg.execute-api.us-west-2.amazonaws.com/prod';
    const videoProgress = reactPlayerRef.current.getCurrentTime() / reactPlayerRef.current.getDuration();
    const date = new Date();
    var data = {
      trainingModule: trainingId,
      status: 'required',
      startDate: date,
      //finishedDate: '',
      //progress: '',
      videoProgress: videoProgress ? Math.floor(videoProgress * 100) : 0,
    };

    fetch(basePCUrl, {
      method: 'POST',
      body: JSON.stringify(data),
      headers: {
        Authorization: `Bearer ${token}`,
        Action: 'updateUserTraining',
        'Content-Type': 'application/json',
      },
    })
      .then((response) => {
        if (response.status !== 200) {
          console.log('Looks like there was a problem. Status Code: ' + response.status);
          //setError(true);
          // console.log(error);
          return;
        }

        response.json().then((data) => {
          return;
        });
      })
      .catch(function (err) {
        console.log('Fetch Error :-S', err);
      });

    if (videoProgress === 1) {
      setIsOpen(true);
    }
  };

  useEffect(() => {
    getAdminConfigSettings();
  }, []);

  useEffect(() => {
    if (pdf) {
      saveTrainingProgress();
    }
  }, [pdf != null]);

  //-----Modern Styling-----//
  const useStyles = makeStyles((theme) => ({
    root: {
      flexGrow: 1,
      background: theme.palette.type === 'dark' ? theme.palette.background.default : 'linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)',
      minHeight: '100vh',
      padding: theme.spacing(3),
    },
    paper: {
      padding: theme.spacing(2),
      textAlign: 'center',
      color: theme.palette.text.secondary,
    },
    headerPaper: {
      padding: theme.spacing(6),
      textAlign: 'center',
      alignContent: 'center',
      height: '100%',
    },
    video: {
      width: '70%',
      minWidth: 500,
    },
    modernButton: {
      background: 'linear-gradient(45deg, #0055A2, #428BC9)',
      color: 'white',
      fontWeight: 600,
      padding: '12px 32px',
      borderRadius: 25,
      fontSize: '1rem',
      textTransform: 'none',
      boxShadow: '0 4px 20px rgba(0, 85, 162, 0.3)',
      minHeight: 48,
      '&:hover': {
        background: 'linear-gradient(45deg, #061739, #0055A2)',
        transform: 'translateY(-2px)',
        boxShadow: '0 6px 25px rgba(0, 85, 162, 0.4)',
      },
    },
    secondaryButton: {
      background: theme.palette.type === 'dark' ? theme.palette.background.paper : 'rgba(255, 255, 255, 0.95)',
      backdropFilter: 'blur(10px)',
      color: '#0055A2',
      fontWeight: 600,
      padding: '12px 32px',
      borderRadius: 25,
      fontSize: '1rem',
      textTransform: 'none',
      border: '2px solid #0055A2',
      minHeight: 48,
      '&:hover': {
        background: '#0055A2',
        color: 'white',
        transform: 'translateY(-2px)',
        boxShadow: '0 6px 25px rgba(0, 85, 162, 0.3)',
      },
    },
    titleSection: {
      background: theme.palette.type === 'dark' ? theme.palette.background.paper : 'rgba(255, 255, 255, 0.95)',
      backdropFilter: 'blur(10px)',
      borderRadius: 16,
      padding: theme.spacing(4),
      marginBottom: theme.spacing(3),
      border: '1px solid rgba(255, 255, 255, 0.2)',
      boxShadow: '0 8px 32px rgba(0, 85, 162, 0.1)',
    },
    videoContainer: {
      background: theme.palette.type === 'dark' ? theme.palette.background.paper : 'rgba(255, 255, 255, 0.95)',
      backdropFilter: 'blur(10px)',
      borderRadius: 16,
      padding: theme.spacing(2),
      border: '1px solid rgba(255, 255, 255, 0.2)',
      boxShadow: '0 8px 32px rgba(0, 85, 162, 0.1)',
      overflow: 'hidden',
    },
  }));

  const classes = useStyles();
  const theme = useTheme();

  const ListItemLink = (props) => {
    return <ListItem button component="a" {...props} />;
  };

  const getTimeEstimate = (timeEstimate) => {
    return Math.floor(timeEstimate / 60) + getTranslation(' minutes', preferredLanguage);
  };

  const pushToQuiz = () => {
    props.history.push('/Dashboard/TrainingQuiz?pad=&id=' + trainingId);
    window.scrollTo({ top: 110, left: 100, behavior: 'smooth' });
  };

  return (
    <span>
      {!isLoadingTraining ? (
        <div className={classes.root}>
          <Grid container direction="row" justify="center" alignItems="center" spacing={4}>
            <Grid item xs={12}>
              <Paper className={classes.titleSection} elevation={0}>
                <Typography variant="h3" component="h1" style={{ fontWeight: 700, color: theme.palette.type === 'dark' ? theme.palette.text.primary : '#1a237e', marginBottom: 16 }}>
                  🎓 {trainingTitle !== null ? trainingTitle : ''}
                </Typography>
                <Typography align="center" variant="h6" style={{ color: '#666', fontWeight: 400, lineHeight: 1.5 }}>
                  {props.trainingData.completionIndicator === 'Q'
                    ? '📋 To successfully complete this training, passing the quiz is required.'
                    : props.trainingData.completionIndicator === 'V'
                    ? '🎥 To successfully complete this training, viewing the entire training video is required.'
                    : '📚 Complete this cybersecurity training to enhance your security awareness.'}
                </Typography>
              </Paper>
              {/* </Grid> */}
              <Grid item>
                {quiz !== null && trainingQuiz !== null && !isLoadingTraining ? (
                  <Grid container direction="row" justify="center" alignItems="end">
                    <Button
                      className={classes.modernButton}
                      variant="contained"
                      style={{ width: '100%', maxWidth: '1000px', marginTop: '16px' }}
                      onClick={pushToQuiz}
                    >
                      📋 {getTranslation('Take Quiz', preferredLanguage)}
                    </Button>
                  </Grid>
                ) : null}
              </Grid>
            </Grid>
            <br />
            <br />
            <Grid item style={{ maxWidth: '1000px', width: '100%' }}>
              <Paper className={classes.videoContainer} elevation={0}>
                <ReactPlayer
                  url={trainingVideo}
                  ref={reactPlayerRef}
                  className="react-player"
                  width="100%"
                  height="100%"
                  style={{ borderRadius: 12 }}
                  controls={true}
                  onPause={(progress) => {
                    console.log(
                      'progress1',
                      progress,
                      reactPlayerRef.current.getDuration(),
                      reactPlayerRef.current.getCurrentTime()
                    );
                    saveTrainingProgress();
                  }}
                  onEnded={() => saveTrainingProgress()}
                />
              </Paper>
            </Grid>
            <Grid container direction="row" justify="center" alignItems="center" spacing={4}>
              <div elevation={0} className={classes.headerPaper}>
                <br />
                <br />
                <br />
                {trainingGraphic !== null ? (
                  <Grid item xs={12} sm={12} md={12} lg={12}>
                    <Button 
                      className={classes.secondaryButton}
                      variant="contained" 
                      onClick={() => setInfographicOpen(!infographicOpen)}
                      style={{ marginBottom: 16 }}
                    >
                      {!infographicOpen
                        ? `📊 ${getTranslation('View Infographic', preferredLanguage)}`
                        : `✖ ${getTranslation('Close Infographic', preferredLanguage)}`}
                    </Button>
                    {infographicOpen ? (
                      <iframe style={{ width: '75vw', height: '75vh' }} src={trainingGraphic} />
                    ) : null}
                  </Grid>
                ) : null}
              </div>
            </Grid>
            <br />
            <br />
            <br />
            <br />
          </Grid>
          <br />
          <br />
        </div>
      ) : (
        <div style={{ width: '60vw', height: '80vh', justifyContent: 'center', alignItems: 'center' }}>
          <div style={{ marginTop: '25%', marginLeft: '10%' }}>
            <h3> {getTranslation('Loading Your Training Content...', preferredLanguage)}</h3>
            <LinearProgress style={{ display: 'block' }} />
          </div>
        </div>
      )}

      <TrainingCompleteModal
      history={props.history}
        preferredLanguage={props.preferredLanguage}
        getTranslation={props.getTranslation}
        completionIndicator={props.trainingData.completionIndicator}
        isOpen={isOpen}
        pushToQuiz={pushToQuiz}
      />
    </span>
  );
};
export default TrainingSuite;

//< Button className = { classes.button } size = "small" color = "primary" >
//    I have completed this training
//                    </Button >

//< Grid item xs = { 12} >
//    <Paper className={classes.headerPaper}>
//        <Typography variant="h4" component="h4">
//            Lesson Title
//                    </Typography>
//    </Paper>
//            </Grid >
